<template>
    <div>
        <div v-for="(item, index) in questionsNum" :key="index">
            <el-form-item label="题目类型">
                <el-select
                    v-model="item.value"
                    placeholder="请选择"
                    style="width: 480px"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    @click="delquestions(index)"
                    circle
                ></el-button>
            </el-form-item>
            <el-form-item label="选项内容">
                <div v-show="item.value === '单选题'">
                    <el-radio-group v-model="item.radioTrue">
                        <div
                            v-for="(item1, index1) in item.options"
                            :key="'radio' + index1"
                        >
                            <el-radio :label="String.fromCharCode(index1 + 65)">
                                {{ String.fromCharCode(index1 + 65) }}
                            </el-radio>

                            <quill-editor v-model="item1.content">
                            </quill-editor>
                        </div>
                    </el-radio-group>
                    <el-button @click="addFn(index)">添加选项</el-button>
                    <el-button @click="delFn(index)">删除选项</el-button>
                </div>
                <div v-show="item.value === '多选题'">
                    <el-checkbox-group v-model="item.checkboxTrue">
                        <div
                            v-for="(item2, index2) in item.options"
                            :key="index2"
                        >
                            <el-checkbox>
                                {{ String.fromCharCode(index2 + 65) }}
                            </el-checkbox>
                            <quill-editor
                                v-model="item2.content"
                            ></quill-editor>
                        </div>
                    </el-checkbox-group>
                    <el-button @click="addFn(index)">添加选项</el-button>
                    <el-button @click="delFn(index)">删除选项</el-button>
                </div>
                <div
                    v-show="item.value === '简答题' || item.value === '论述题'"
                >
                    <quill-editor v-model="item.content1"></quill-editor>
                </div>
            </el-form-item>
            <el-form-item label="解析">
                <quill-editor v-model="item.content2"></quill-editor>
            </el-form-item>
        </div>
        <div></div>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
    data() {
        return {
            // 题目类型
            options: [
                {
                    value: "单选题",
                },
                {
                    value: "多选题",
                },
                {
                    value: "简答题",
                },
                {
                    value: "论述题",
                },
            ],
            questionsNum: [],
        };
    },
    components: {
        quillEditor,
    },
    props: {
        questions: {
            type: Array,
            default: () => [],
        },
    },

    created() {
        this.init();
    },
    methods: {
        init() {
            this.questionsNum = [...this.questions];
        },
        delquestions(i) {
            this.questionsNum.splice(i, 1);
        },
        addFn(i) {
            this.$nextTick(() => {
                this.questionsNum[i].options.push({
                    // 选项内容
                    content: "",
                });
            });
        },
        delFn(i) {
            this.questionsNum[i].options.pop();
        },
    },
    watch: {
        // questionsNum: function (newValue, oldValue) {
        //     this.$emit("update:questions", newValue);
        // },
    },
};
</script>

<style lang="scss" scoped>
.select {
    width: 480px;
}
</style>